import { StratumService, WINDOW_DEBUG_FLAG_KEY } from '@cof/stratum';
import {
  PRODUCT_NAME,
  PRODUCT_VERSION,
  TAG_CATALOG,
  PLUGINS,
} from '@cof/tag-catalog-fs-lienholder-mfe';

export const stratum = new StratumService(TAG_CATALOG, {
  productName: PRODUCT_NAME,
  productVersion: PRODUCT_VERSION,
  plugins: PLUGINS,
});

const hosts = [
  'coaf-lienholder-mfe.capitalone.com',
  'coaf-refi-web-ui.capitalone.com',
];

if (!hosts.includes(window.location.host)) {
  window[WINDOW_DEBUG_FLAG_KEY] = true;
  stratum.addEventListener((event) => {
    console.log('Stratum Event Received', event);
  });
}
